// Core state
import { createStore } from 'vuex'

import {authState} from "src/modules/auth/state";
//import {orderState} from "src/modules/order/state";

export const store = createStore({
    state: {
        preloader: false,
        preloaderCount: 0,
    },
    mutations: {
        loading(state, data) {
            state.preloader = data;
            if (!data) {
                state.preloaderCount = 0;
            }
        },
        loadingIncrement(state) {
            state.preloaderCount++;
            state.preloader = state.preloaderCount > 0;
        },
        loadingDecrement(state) {
            state.preloaderCount = Math.max(0, state.preloaderCount - 1);
            state.preloader = state.preloaderCount > 0;
        },
    },
    actions: {
        coreShowLoading: ({commit}) => {
            commit('loadingIncrement');
        },
        coreHideLoading: ({commit}) => {
            commit('loadingDecrement');
        },
        coreResetLoading: ({commit}) => {
            commit('loading', false);
        },
    },
    getters: {
        coreGetPreloaderStatus: state => {
            return state.preloader;
        },
        coreIsLoading: state => {
            return state.preloaderCount > 0;
        },
    },
    // cargo los modulos
    modules: {
        auth: authState,
        //order: orderState,
    },
})
